//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 05/09/2024
// Version : 1
// Description : Tabla de proximas fechas de revision
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React from "react";
import { Box, Grid, TextField } from "@mui/material";
import moment from "moment";

function Prox_fechas_revisiones({ datosTanque }) {
  const style = {
    backgroundColor: "#ffffff",
  };
  const size = "small";

  return (
    <div>
      <br />
      <br />
      <Grid container spacing={2}>
        {/* Box General - Todo en 4 columnas */}
        <Grid item xs={12}>
          <Box
            backgroundColor="#F4F6F6"
            p={2}
            border={0.5}
            borderColor="#ABB2B9"
            borderRadius={4}
          >
            <Grid container spacing={2}>
              {/* Quinquenal */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Ultima revisión quinquenal"
                  variant="outlined"
                  value={moment(datosTanque.fecha_ultima).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Próx. rev. quinquenal"
                  variant="outlined"
                  value={moment(datosTanque.prox_ultima).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* VTV */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Ultima V.T.V"
                  variant="outlined"
                  value={moment(datosTanque.fecha_vtv).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Próx. V.T.V"
                  variant="outlined"
                  value={moment(datosTanque.prox_vtv).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Válvulas seguridad */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Ultima rev. válvulas seguridad"
                  variant="outlined"
                  value={moment(datosTanque.fecha_rev_val_seg).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Próx. rev. válvulas seguridad"
                  variant="outlined"
                  value={moment(datosTanque.prox_rev_val_seg).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Oblea matafuegos */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Oblea matafuegos"
                  variant="outlined"
                  value={moment(datosTanque.fecha_oblea_matafuegos).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Vencimiento oblea"
                  variant="outlined"
                  value={moment(datosTanque.prox_oblea_matafuegos).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Mangueras */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Ultima rev. mangueras"
                  variant="outlined"
                  value={moment(datosTanque.fecha_rev_man).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Próx. rev. mangueras"
                  variant="outlined"
                  value={moment(datosTanque.prox_rev_man).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Seguro */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Seguro"
                  variant="outlined"
                  value={moment(datosTanque.fecha_seguro).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Vencimiento seguro"
                  variant="outlined"
                  value={moment(datosTanque.prox_seguro).format("DD-MM-YYYY")}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Válvulas exceso */}
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Ultima rev. válvulas exceso"
                  variant="outlined"
                  value={moment(datosTanque.fecha_rev_val_exc).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Próx. rev. válvulas exceso"
                  variant="outlined"
                  value={moment(datosTanque.prox_rev_val_exc).format(
                    "DD-MM-YYYY"
                  )}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              {/* Datos */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size={size}
                  style={style}
                  focused
                  color="primary"
                  label="Datos"
                  variant="outlined"
                  value={datosTanque.datos}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default Prox_fechas_revisiones;
